export enum NotificationType {
  ASSIGNMENT_NEW = "ASSIGNMENT_NEW",
  ASSIGNMENT_SUBMITTED = "ASSIGNMENT_SUBMITTED",
  ASSIGNMENT_TASK_SCORED = "ASSIGNMENT_TASK_SCORED",
  ASSIGNMENT_CLOSED = "ASSIGNMENT_CLOSED",
  ASSIGNMENT_DUE_SOON = "ASSIGNMENT_DUE_SOON",
  TEACHER_FEEDBACK = "TEACHER_FEEDBACK",
  ENERGY_LOW = "ENERGY_LOW",
  ENERGY_REFILLED = "ENERGY_REFILLED",
  PAYMENT_SUCCESS = "PAYMENT_SUCCESS",
  PAYMENT_FAILED = "PAYMENT_FAILED",
  SUBSCRIPTION_EXPIRING = "SUBSCRIPTION_EXPIRING",
  SUBSCRIPTION_EXPIRED = "SUBSCRIPTION_EXPIRED",
  SYSTEM_ANNOUNCEMENT = "SYSTEM_ANNOUNCEMENT",
}

export interface INotification {
  _id: string;
  userId: string;
  type: NotificationType;
  title: string;
  body: string;
  data: Record<string, any>;
  isRead: boolean;
  readAt: string | null;
  createdAt: string;
}

export interface INotificationListResponse {
  items: INotification[];
  total: number;
  unreadCount: number;
}

export interface INotificationState {
  notifications: INotification[];
  unreadCount: number;
  isDrawerOpen: boolean;
  isConnected: boolean;
}
